import {Action, Dispatch} from 'redux';
import batchAPI from '../APIs/batchAPI';

const TYPES = {
    UPLOAD_BATCH_PROGRESS: 'UPLOAD_BATCH_PROGRESS',
    UPLOAD_BATCH_SUCCESS: 'UPLOAD_BATCH_SUCCESS',
    UPLOAD_BATCH_FINAL_SUCCESS: 'UPLOAD_BATCH_FINAL_SUCCESS',
    FETCH_ACTION_CODE_SUCCESS: 'FETCH_ACTION_CODE_SUCCESS',
    FETCH_TEMPLATE_SUCCESS: 'FETCH_TEMPLATE_SUCCESS'
};

const uploadBatch = (data: FormData) => {
    return function (dispatch: Dispatch<Action>) {
        const uploadProgress = {
            onUploadProgress: (progressEvent) => {
                let progress = 0;
                const totalSize = progressEvent.lengthComputable ? progressEvent.total : progressEvent.target.getResponseHeader('content-length') || progressEvent.target.getResponseHeader('x-decompressed-content-length');
                if (totalSize) { progress = Math.round((progressEvent.loaded*100)/totalSize); }
                dispatch(storeUploadProgress(progress));
            },
        };
        return batchAPI.uploadBatch(data, uploadProgress).then(res => {
            dispatch(storeUploadBatchStatus(res.data));
        }).catch(error => {
            throw(error);
        });
    };
};

const uploadBatchFinal = (data: FormData) => {
    return function (dispatch: Dispatch<Action>) {
        return batchAPI.uploadBatchFinal(data).then(res => {
            dispatch(storeUploadBatchFinalStatus(res.data));
        }).catch(error => {
            throw(error);
        });
    };
};

const fetchActionCode = () => {
    return function (dispatch: Dispatch<Action>) {
        return batchAPI.actionCode().then(res => {
            dispatch(storeActionCode(res.data));
        }).catch(error => {
            throw(error);
        });
    };
};

const fetchTemplate = () => {
    return function (dispatch: Dispatch<Action>) {
        return batchAPI.template().then(res => {
            dispatch(storeTemplate(res.data));
        }).catch(error => {
            throw(error);
        });
    };
};

const storeUploadProgress = (data: number) => {
    return {
        type: TYPES.UPLOAD_BATCH_PROGRESS,
        uploadProgress: data
    };
};

const storeUploadBatchStatus = (data: object) => {
    return {
        type: TYPES.UPLOAD_BATCH_SUCCESS,
        uploadResult: data
    };
};

const storeUploadBatchFinalStatus = (data: object) => {
    return {
        type: TYPES.UPLOAD_BATCH_FINAL_SUCCESS,
        finalUploadResult: data
    };
};

const storeActionCode = (data: object) => {
    return {
        type: TYPES.FETCH_ACTION_CODE_SUCCESS,
        actionCode: data
    };
};

const storeTemplate = (data: object) => {
    return {
        type: TYPES.FETCH_TEMPLATE_SUCCESS,
        template: data
    };
};

export {TYPES, uploadBatch, uploadBatchFinal, fetchActionCode, fetchTemplate};


// WEBPACK FOOTER //
// ./src/ReduxRequests/Actions/batchAction.ts